import { DateFormatHelper } from '@/ui-kit/helpers/DateFormatHelper';
import { createDate } from '@/utils/date';
import { DEFAULT_VIEWING_DURATION_IN_MINUTES } from '../constants';

export default class BookViewingPayloadMapper {
  static mapBodePayload({ day, time }) {
    return {
      appointments: [this.#createBodeAppointment(day, time)],
    };
  }

  static #createBodeAppointment(day, time) {
    const startDate = createDate({ datetime: day })
      .hour(time.hour)
      .minute(time.minutes);

    return this.#createAppointment(startDate, DEFAULT_VIEWING_DURATION_IN_MINUTES);
  }

  static #createAppointment(startDate, duration) {
    return {
      startTime: startDate.toISOString(),
      endTime: startDate.add(duration, 'minute').toISOString(),
      timezone: DateFormatHelper.getTimezone(),
    };
  }
}
